import bankingAlertsReducer from './bankingAlertsReducer';
import accountAlertsReducer from './accountAlertsReducer';
import deliveryMethodReducer from './deliveryMethodReducer';
import accountAlertPreferencesReducer from './accountAlertPreferencesReducer';
import accountAlertTypesReducer from './accountAlertTypesReducer';
import { combineReducers } from 'redux';

const rootReducer= combineReducers({
         bankingAlertsReducer,
         accountAlertsReducer,
         deliveryMethodReducer,
         accountAlertPreferencesReducer,
         accountAlertTypesReducer
    });

    export default rootReducer;